import { Checkbox } from "@mui/material";
import PropTypes from "prop-types";
import React, { Fragment, useEffect, useState } from "react";
import {
  useExpanded,
  useFilters,
  useGlobalFilter,
  usePagination,
  useSortBy,
  useTable,
} from "react-table";
import { Table } from "reactstrap";
import no_data_image from "../../assets/images/table_empty_image.png";
import { DefaultColumnFilter } from "./filters";

// Define a default UI for filtering

const TableContainer = ({
  columns = [],
  data = [],
  customPageSize,
  className,
  filter, addButtonTite, addLink, getLengthPage, totalPage, children, open, SetOpen, customToolsBar, checkedAll, setCheckedAll, module,
  sort, setSorted, sort_by, setSortBy
}) => {
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page,
    prepareRow,
    setPageSize,
    state: { pageIndex, pageSize },
  } = useTable(
    {
      columns,
      data,
      defaultColumn: { Filter: DefaultColumnFilter },
      initialState: {
        pageIndex: 0,
        pageSize: customPageSize,
        // sortBy: [
        //   {
        //     desc: true,
        //   },
        // ],
      },
    },
    useGlobalFilter,
    useFilters,
    useSortBy,
    useExpanded,
    usePagination
  );

  const [pageNo, setPage] = useState(1)
  const [id, setID] = useState("")

  // const generateSortingIndicator = column => {
  //   return (
  //     <>
  //       {
  //         column.isSorted ?
  //           (column.isSortedDesc ? <i className="ri-sort-desc p-2"></i> : <i className="ri-sort-asc p-2"></i>) : <i className="ri-arrow-up-down-line p-2"></i>
  //       }
  //     </>
  //   )
  // };
  useEffect(() => {
    if (customPageSize && (pageSize !== customPageSize)) {
      setPageSize(customPageSize)
    }
  }, [customPageSize])

  const generateSortingIndicator = column => {
    if (sort === "asc") {
      return <i className="ri-arrow-up-s-fill p-2"></i>
    } else if (sort === "desc")
      return <i className="ri-arrow-down-s-fill p-2"></i>
  };

  const handleSort = (columnID, idx) => {
    setSortBy && setSortBy(columnID?.columnID)
    setID(idx)
    sort === "asc" ? setSorted("desc") : setSorted("asc")
  }

  return (
    <Fragment>
      <div className="table-responsive react-table" style={{ backgroundColor: 'white' }}>
        <Table hover {...getTableProps()} className={className} responsive>
          <thead className="table-light table-nowrap">
            {headerGroups.map((headerGroup, idx) => (
              <tr key={idx} style={{ fontFamily: 'Manrope-Bold', position: 'relative' }}>
                {headerGroup.headers.map((column, idx) => (
                  <th
                    key={idx}
                    style={
                      column?.position === 'sticky' ? { minWidth: column?.minWidth || 0, position: 'sticky', right: 0, zIndex: 2, backgroundColor: '#F9F9F9' } :
                        { minWidth: column?.minWidth || 0, backgroundColor: '#F9F9F9' }
                    }
                  >
                    {
                      column.render("Header") === "#" ?
                        <Checkbox checked={Boolean(checkedAll)} sx={{
                          paddingBlock: 0,
                          color: '#D0D0D0',
                          '&.Mui-checked': {
                            color: "var(--bs-theme-color)",
                          },
                        }} onChange={(event) => setCheckedAll(!checkedAll)} />
                        : column.render("Header") === "Claimed?" ?
                          <div className="d-flex align-items-end justify-content-center row m-0">
                            <div style={{ color: '#505D69' }}>
                              {column.render("Header")}
                            </div>
                            <div className="d-flex justify-content-center">
                              <Checkbox checked={Boolean(checkedAll)} sx={{
                                '&.Mui-checked': {
                                  color: "var(--bs-theme-color)",
                                },
                                padding: 0
                              }} onChange={(event) => setCheckedAll(!checkedAll)} />
                            </div>
                          </div>
                          :
                          <div style={{ color: '#505D69', cursor: "pointer", }} onClick={(e) => columns[idx]?.columnID ? handleSort(columns[idx], idx) : ""}>
                            {column.render("Header")}
                            {columns[idx]?.columnID ? id === idx ? generateSortingIndicator(column) : <i className="ri-expand-up-down-fill p-2"></i> : ""}
                          </div>
                    }
                    {/* <Filter column={column} /> */}
                  </th>
                ))}
              </tr>
            ))}
          </thead>
          {
            Array.isArray(data) && data?.length > 0 &&
            <tbody {...getTableBodyProps()}>

              {page.map((row, idx) => {
                prepareRow(row);
                return (
                  <tr key={idx}
                    style={{ backgroundColor: 'white' }}>
                    {row.cells.map((cell, idx) => (
                      <td key={idx}
                        style={
                          cell.column.Header === 'Action' ?
                            { color: '#505D69', position: 'sticky', right: 0, zIndex: 2, backgroundColor: 'white' }
                            :
                            { color: '#505D69', backgroundColor: 'white' }
                        }>
                        {cell.render("Cell")}
                      </td>
                    ))}
                  </tr>
                );
              })}
            </tbody>
          }
        </Table>
        {

          data?.length <= 0 &&
          <>
            <div className="d-flex justify-content-center w-100 pb-2" key={'no record-1'}>
              <img src={no_data_image} alt="empty-data" style={{ height: 120, width: 120 }} />
            </div>
            <div className="d-flex justify-content-center w-100 pb-2" key={'no record-2'} style={{ marginBottom: 10, color: '#999999' }}>
              No data available
            </div>
          </>
        }
      </div>

    </Fragment>
  );
};

TableContainer.propTypes = {
  preGlobalFilteredRows: PropTypes.any,
};

export default TableContainer;
